//imports
import '../App.css';

import React, {useState} from 'react';



//import overwrites


function Legal() {
 

  return (
    <>  
        <br />
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            <hr class="my-2" />
            <h3>Zanances USAR</h3>
            <h1>503rd Battalion</h1>
            <hr class="my-4" />
        </div>
        <div style={{margin: "auto", width: "50%"}} >
            <h3>General Information</h3>
            <ul class="list-group">
                <li class="list-group-item">Publisher: CongTviy09</li>
                <li class="list-group-item">Owner: CongTviy09</li>
                <li class="list-group-item">Creator: Noay_HD1</li>
                <li class="list-group-item">Maintainer: Noay_HD1</li>
            </ul>
            <br />

            <br />
            <h3>Privacy Policy</h3>
            <p><b>Effective Date: 17/04/25</b><br />
              This Privacy Policy describes how we collect, use, and protect your information when you use our website. We are committed to respecting your privacy and ensuring that your personal data is handled in accordance with the Data Privacy Act of 2012 and other applicable laws of the Philippines.
              <br /><br />
              <b>1. Information We Collect</b><br />
              When you use our website, we may collect the following types of information:
            </p>
            <ul class="list-group">
              <li class="list-group-item">IP Addresses</li>
              <li class="list-group-item">User Input: Any data typed into input fields on the site (e.g., names, messages)</li>
            </ul>
            <p><br />
              <b>2. How We Use Your Information</b><br />
              The data we collect is used solely for functional purposes, including but not limited to:
            </p>
            <ul class="list-group">
              <li class="list-group-item">Enhancing site usability</li>
              <li class="list-group-item">Managing session and user-specific content</li>
            </ul>
            <p>We do not use your data for marketing, profiling, or analytics.
            <br /><br />
              <b>3. Data Sharing</b><br />
              We do not share your personal information with any third parties. Your data remains securely stored and is only accessible to authorized maintainers of the website.
              <br /><br />
              <b>4. Data Retention</b><br />
              We retain your personal information for an unlimited period, unless you request otherwise (see Section 5). This retention allows us to provide consistent functionality and user experience.
              <br /><br />
              <b>5. Your Rights Under the Data Privacy Act</b><br />
              As a data subject, you have the right to:
            </p>
            <ul class="list-group">
              <li class="list-group-item">Access your personal data</li>
              <li class="list-group-item">Correct any inaccurate or outdated information</li>
              <li class="list-group-item">Request deletion of your personal data</li>
            </ul>
            <p>To exercise these rights, please contact the site maintainer directly (see Section 6).<br /><br />
              <b>6. Contact Information</b><br />
              For privacy-related concerns or to exercise your data rights, please contact the 503rd Battalion HICOM via the <a href='https://discord.gg/7WUwcBqAPc'>Discord ticketing system</a>.
              <br /><br />
              <b>7. Cookies</b><br />
              Our website uses cookies that are strictly necessary for its core functionality. These include cookies for secure access, page navigation, and session management.
              We do not use cookies for tracking, analytics, or advertising. No personal information is shared through cookies beyond what is required for the requested services.
              <br />
              <b>8. Changes to This Privacy Policy</b><br />
              We may update this Privacy Policy from time to time. Changes will be posted on this page with the revised effective date. Your continued use of the website constitutes acceptance of any modifications.

            </p>
            <br />
            <br />
            <h3>Terms of Use</h3>
            <p>
            <b>Effective Date: 17/04/25</b><br />
            By accessing and using this website, you agree to comply with and be bound by the following Terms of Use. If you do not agree with any part of these terms, you should not use this website.<br /><br />
            <b>1. Acceptance of Terms</b><br />
            By using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use and any updates posted on this page.<br /><br />
            <b>2. User Conduct</b><br />
            We reserve the right to change or update these Terms at any time. Updates will be posted on this page. Continued use of the site after changes constitutes acceptance of those changes.<br /><br />
            <b>3. Use of the Website</b><br />
            You agree to use the website only for its intended purpose. You must not:
            </p>
            <ul class="list-group">
              <li class="list-group-item">Use the site for unlawful activities</li>
              <li class="list-group-item">Attempt to gain unauthorized access to the website or its systems</li>
              <li class="list-group-item">Attempt to gain unauthorized access to someone elses account</li>
              <li class="list-group-item">Upload or input malicious code or abusive content</li>
            </ul>
            <p>
              <br />
              <b>4. User Responsibilitie</b><br />
              You are responsible for any content you enter into the website’s input fields. You agree not to submit any false, offensive, or misleading information. <br /> <br />

              <b>5. Intellectual Property</b> <br />
              All content and materials on this website, unless otherwise stated, are the intellectual property of the site owner or contributors. You may not copy, distribute, or reproduce any part without permission. <br /><br />

              <b>6. Privacy</b> <br />
              Please review our Privacy Policy for information on how we collect and use your data. <br /><br />

              <b>7. Limitation of Liability</b><br />
              This website is provided “as is” without warranties of any kind. We are not liable for any direct or indirect damages arising from your use of the site. <br /><br />

              <b>8. Termination</b><br />
              We reserve the right to suspend or terminate access to the website for any user who violates these terms, without notice. <br /><br />

              <b>9. Governing Law</b><br />
              These Terms are governed by the laws of the Republic of the Philippines, without regard to its conflict of law principles. <br /><br />

              <b>10. Contact Information</b><br />
              For any questions or concerns regarding these Terms, please contact the 503rd Battalion Staff via <a href='https://discord.gg/7WUwcBqAPc'>Discord</a>.
            </p>

                
                
                
                
                
        </div>
        
    </>
  );
}



export default Legal;
